/* Leigona theme behaviour: overlays, Ajax cart drawer, product options, home tabs and swatches,
   collection filters and sorting. No dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel)
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)]
  const routes = window.routes || {}

  /* ---------- Overlays (menu, cart drawer, bottom sheets) ---------- */
  let openOverlay = null
  let lastFocus = null
  function open(el) {
    if (!el) return
    if (openOverlay && openOverlay !== el) close(openOverlay)
    lastFocus = document.activeElement
    el.hidden = false
    document.body.style.overflow = 'hidden'
    openOverlay = el
    const focusable = el.querySelector('[data-cart-close], [data-menu-close], [data-sheet-close], button, a')
    if (focusable) focusable.focus({ preventScroll: true })
  }
  function close(el) {
    if (!el || el.hidden) return
    el.hidden = true
    document.body.style.overflow = ''
    if (openOverlay === el) openOverlay = null
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true })
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openOverlay) close(openOverlay)
  })

  /* ---------- Menu drawer ---------- */
  const menu = $('[data-menu]')
  const menuBtn = $('[data-menu-open]')
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) {
      open(menu)
      menuBtn && menuBtn.setAttribute('aria-expanded', 'true')
    } else if (e.target.closest('[data-menu-close]')) {
      close(menu)
      menuBtn && menuBtn.setAttribute('aria-expanded', 'false')
    }
  })

  /* ---------- Money ---------- */
  const moneyFormat = (() => {
    const el = $('[data-product-json]')
    try { return el ? JSON.parse(el.textContent).moneyFormat : null } catch { return null }
  })() || '₹{{amount}}'
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2)
    const [whole, frac] = value.split('.')
    const group = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep)
    const amount = frac === '00' ? group(',') : `${group(',')}.${frac}`
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return group(',')
      if (key === 'amount_with_comma_separator') return frac === '00' ? group('.') : `${group('.')},${frac}`
      if (key === 'amount_no_decimals_with_comma_separator') return group('.')
      return amount
    })
  }

  /* ---------- Cart drawer ---------- */
  const drawer = () => $('[data-cart-drawer]')

  async function renderCart() {
    const res = await fetch(`${routes.root || '/'}?sections=cart-drawer`, { headers: { Accept: 'application/json' } })
    const data = await res.json()
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html')
    const fresh = $('[data-cart-panel]', doc)
    const panel = $('[data-cart-panel]')
    if (fresh && panel) panel.innerHTML = fresh.innerHTML
    const countSource = $('[data-cart-count-source]')
    const count = countSource ? Number(countSource.textContent) : 0
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count
      el.hidden = count === 0
      const btn = el.closest('[data-cart-open]')
      if (btn) btn.setAttribute('aria-label', `Cart, ${count} items`)
    })
  }

  async function cartPost(url, body) {
    const isForm = body instanceof FormData
    const res = await fetch(url, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? body : JSON.stringify(body),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.')
    return data
  }

  async function addToCart(formData, button, errorEl) {
    if (button) { button.classList.add('is-loading'); button.disabled = true }
    if (errorEl) errorEl.hidden = true
    try {
      await cartPost(`${routes.cartAdd || '/cart/add'}.js`, formData)
      await renderCart()
      open(drawer())
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false } else alert(err.message)
    } finally {
      if (button) { button.classList.remove('is-loading'); button.disabled = false }
    }
  }

  function setCouponNote(text) {
    const note = $('[data-coupon-note]')
    if (!note) return
    note.textContent = text || ''
    note.hidden = !text
  }

  async function applyDiscount(codes, note) {
    const cart = await cartPost(`${routes.cartUpdate || '/cart/update'}.js`, { discount: codes.join(',') })
    await renderCart()
    if (note) {
      const bad = (cart.discount_codes || []).find((d) => !d.applicable)
      if (bad) setCouponNote(`${bad.code} cannot be used on this cart.`)
    }
  }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]')
    if (openBtn && drawer()) {
      e.preventDefault()
      open(drawer())
      return
    }
    if (e.target.closest('[data-cart-close]')) {
      close(drawer())
      return
    }
    const qtyBtn = e.target.closest('[data-cart-qty]')
    if (qtyBtn) {
      qtyBtn.disabled = true
      try {
        await cartPost(`${routes.cartChange || '/cart/change'}.js`, { id: qtyBtn.dataset.cartQty, quantity: Number(qtyBtn.dataset.qty) })
        await renderCart()
      } catch (err) {
        setCouponNote(err.message)
        qtyBtn.disabled = false
      }
      return
    }
    const upsell = e.target.closest('[data-cart-add]')
    if (upsell) {
      const fd = new FormData()
      fd.append('id', upsell.dataset.cartAdd)
      fd.append('quantity', '1')
      addToCart(fd, upsell)
      return
    }
    const removeCode = e.target.closest('[data-coupon-remove]')
    if (removeCode) {
      const keep = $$('[data-coupon-remove]').map((b) => b.dataset.couponRemove).filter((c) => c !== removeCode.dataset.couponRemove)
      removeCode.disabled = true
      try { await applyDiscount(keep, false) } catch (err) { setCouponNote(err.message) }
    }
  })

  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-coupon-input]')) {
      const apply = $('[data-coupon-apply]')
      if (apply) apply.disabled = !e.target.value.trim()
      setCouponNote('')
    }
  })

  document.addEventListener('submit', (e) => {
    const form = e.target
    if (form.matches('[data-coupon-form]')) {
      e.preventDefault()
      const code = form.elements.code.value.trim().toUpperCase()
      if (!code) return
      applyDiscount([code], true).catch((err) => setCouponNote(err.message))
      return
    }
    if (form.matches('[data-add-form], [data-product-form]')) {
      if (!drawer()) return // no drawer: let the form post to /cart normally
      e.preventDefault()
      const button = e.submitter || form.querySelector('[type="submit"]')
      const errorEl = form.matches('[data-product-form]') ? $('[data-product-error]') : null
      addToCart(new FormData(form), button, errorEl)
    }
  })

  /* ---------- Product cards: pick a variant on the card ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-card-value]')
    if (!btn) return
    const card = btn.closest('[data-card]')
    const json = card && $('[data-card-json]', card)
    if (!json) return
    const variants = JSON.parse(json.textContent)
    const index = Number(btn.closest('[data-card-option]').dataset.cardOption)
    const idInput = $('[data-card-variant]', card)
    const want = (variants.find((v) => String(v.id) === idInput.value) || variants[0]).options.slice()
    want[index] = btn.dataset.cardValue
    const variant = variants.find((v) => v.options.every((o, i) => o === want[i]))
      || variants.find((v) => v.options[index] === btn.dataset.cardValue && v.available)
      || variants.find((v) => v.options[index] === btn.dataset.cardValue)
    if (!variant) return

    idInput.value = variant.id
    $$('[data-card-option]', card).forEach((group) => {
      const i = Number(group.dataset.cardOption)
      $$('[data-card-value]', group).forEach((b) => {
        const on = b.dataset.cardValue === variant.options[i]
        b.classList.toggle('is-active', on)
        b.setAttribute('aria-pressed', String(on))
      })
    })
    $('[data-card-price]', card).textContent = variant.price
    const compare = $('[data-card-compare]', card)
    const save = $('[data-card-save]', card)
    compare.hidden = !variant.compare
    save.hidden = !variant.compare
    if (variant.compare) { compare.textContent = variant.compare; save.textContent = `Save ${variant.save}%` }
    const add = $('[data-card-add]', card)
    add.disabled = !variant.available
    add.textContent = variant.available ? 'Add to cart' : 'Sold out'
    const colour = $('[data-card-colour]', card)
    const swatchGroup = $('.swatches[data-card-option]', card)
    if (colour && swatchGroup) colour.textContent = variant.options[Number(swatchGroup.dataset.cardOption)]
    const link = $('[data-card-link]', card)
    if (link) link.href = variant.url
    const img = $('[data-card-image]', card)
    if (img && variant.image) { img.removeAttribute('srcset'); img.src = variant.image }
  })

  /* ---------- Testimonials: pause the auto-scroll while a finger is on it ---------- */
  $$('.marquee').forEach((m) => {
    m.addEventListener('touchstart', () => m.classList.add('is-paused'), { passive: true })
    m.addEventListener('touchend', () => m.classList.remove('is-paused'))
    m.addEventListener('touchcancel', () => m.classList.remove('is-paused'))
  })

  /* ---------- Shoppable videos: play while on screen, tap for sound, arrows scroll ---------- */
  $$('[data-reels]').forEach((root) => {
    const row = $('[data-reels-row]', root)
    const videos = $$('[data-reel-video]', root)
    const setSound = (video, on) => {
      video.muted = !on
      const btn = video.parentElement.querySelector('[data-reel-sound]')
      if (btn) { btn.setAttribute('aria-pressed', String(on)); btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on') }
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
        const v = entry.target
        if (entry.isIntersecting) {
          v.preload = 'auto'
          v.play().catch(() => {})
        } else {
          v.pause()
          setSound(v, false)
        }
      }), { threshold: 0.6 })
      videos.forEach((v) => io.observe(v))
    }
    root.addEventListener('click', (e) => {
      const media = e.target.closest('.reel__media')
      if (!media) return
      const video = $('[data-reel-video]', media)
      if (!video) return
      const on = video.muted
      // Only one reel plays sound at a time.
      videos.forEach((v) => { if (v !== video) setSound(v, false) })
      setSound(video, on)
      if (video.paused) video.play().catch(() => {})
    })
    const step = (dir) => {
      const card = $('.reel', row)
      row.scrollBy({ left: dir * (card ? card.offsetWidth + 24 : row.clientWidth), behavior: 'smooth' })
    }
    const prev = $('[data-reels-prev]', root)
    const next = $('[data-reels-next]', root)
    if (prev) prev.addEventListener('click', () => step(-1))
    if (next) next.addEventListener('click', () => step(1))
  })

  /* ---------- Home: tabbed products ---------- */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[data-tab]', root)
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => {
        const on = t === tab
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-selected', String(on))
        const panel = document.getElementById(t.getAttribute('aria-controls'))
        if (panel) panel.hidden = !on
      })
    }))
  })

  /* ---------- Home: colour picker ---------- */
  $$('[data-colours]').forEach((root) => {
    const art = $('[data-cookware]', root)
    const name = $('[data-glaze-name]', root)
    const note = $('[data-glaze-note]', root)
    const link = $('[data-glaze-link]', root)
    const swatches = $$('[data-glaze]', root)
    swatches.forEach((sw) => sw.addEventListener('click', () => {
      swatches.forEach((s) => {
        s.classList.toggle('is-active', s === sw)
        s.setAttribute('aria-pressed', String(s === sw))
      })
      if (art) { art.style.color = sw.dataset.hex; art.setAttribute('aria-label', `Dutch oven in ${sw.dataset.name}`) }
      if (name) name.textContent = sw.dataset.name
      if (note) note.textContent = sw.dataset.note
      if (link) link.href = sw.dataset.link
    }))
  })

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const json = $('[data-product-json]', root)
    if (!json) return
    const data = JSON.parse(json.textContent)
    const form = $('[data-product-form]', root)
    const idInput = $('[data-variant-id]', root)
    const optionGroups = $$('[data-option]', root)
    const stickySelects = $$('[data-sticky-option]', root)
    const addButtons = $$('[data-add-button]', root)
    const sticky = $('[data-sticky-atc]', root)
    const mainAdd = form && $('[data-add-button]', form)
    let qty = 1
    const initialImg = $('[data-media]:not([hidden])', root) || $('[data-media]', root)
    const defaultMediaId = data.featuredMediaId || (initialImg ? initialImg.dataset.media : null)

    const current = () => data.variants.find((v) => String(v.id) === idInput.value) || data.variants[0]
    const selected = () => {
      const v = current()
      return v.options.slice()
    }

    function showMedia(id) {
      if (!id) return
      const main = $('.pdp__main', root)
      const target = $(`[data-media="${id}"]`, main)
      if (!target) return
      $$('[data-media]', main).forEach((img) => { img.hidden = img !== target })
      $$('[data-thumb]', root).forEach((t) => {
        const on = t.dataset.thumb === String(id)
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-pressed', String(on))
        // Keep the active thumbnail in view when the row scrolls (phones).
        if (on && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          const row = t.parentElement
          row.scrollTo({ left: t.offsetLeft - row.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' })
        }
      })
      const stickyImg = $('.sticky-atc__media img', root)
      if (stickyImg && target.src) {
        stickyImg.src = target.src
      }
    }

    function update(variant, { media = true } = {}) {
      if (!variant) {
        addButtons.forEach((b) => { b.disabled = true; b.textContent = 'Unavailable' })
        return
      }
      idInput.value = variant.id
      $('[data-price]', root).textContent = formatMoney(variant.price)
      const compare = $('[data-compare]', root)
      const save = $('[data-save]', root)
      const onOffer = variant.compare > variant.price
      compare.hidden = !onOffer
      save.hidden = !onOffer
      if (onOffer) {
        compare.textContent = formatMoney(variant.compare)
        save.textContent = `Save ${Math.round((1 - variant.price / variant.compare) * 100)}%`
      }
      addButtons.forEach((b) => { b.disabled = !variant.available; b.textContent = variant.available ? 'Add to cart' : 'Sold out' })
      optionGroups.forEach((group) => {
        const i = Number(group.dataset.option)
        $$('[data-value]', group).forEach((btn) => {
          const on = btn.dataset.value === variant.options[i]
          btn.classList.toggle('is-active', on)
          btn.setAttribute('aria-pressed', String(on))
        })
        const label = $('[data-option-label]', group)
        if (label) label.textContent = variant.options[i]
      })
      stickySelects.forEach((sel) => { sel.value = variant.options[Number(sel.dataset.stickyOption)] })
      $$('[data-spec-option]', root).forEach((dd) => { dd.textContent = variant.options[Number(dd.dataset.specOption)] })
      const weight = $('[data-spec-weight]', root)
      const weightLabel = $('[data-spec-weight-label]', root)
      if (weight) { weight.textContent = variant.weight; weight.hidden = !variant.hasWeight; weightLabel.hidden = !variant.hasWeight }
      const meta = $('[data-sticky-meta]', root)
      if (meta) meta.textContent = variant.title
      const stickyPrice = $('[data-sticky-price]', root)
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price * qty)
      if (media) {
        const targetMediaId = variant.media || defaultMediaId
        if (targetMediaId) {
          showMedia(targetMediaId)
        }
      }
      // The product page keeps ?variant= in the URL; a featured product on another page does not.
      if (!root.hasAttribute('data-keep-url')) {
        const url = new URL(window.location.href)
        url.searchParams.set('variant', variant.id)
        window.history.replaceState({}, '', url)
      }
    }

    function choose(index, value) {
      const want = selected()
      want[index] = value
      const exact = data.variants.find((v) => v.options.every((o, i) => o === want[i]))
      // If that combination does not exist, keep the picked value and take the first variant that has it.
      const fallback = data.variants.find((v) => v.options[index] === value && v.available) || data.variants.find((v) => v.options[index] === value)
      update(exact || fallback)
    }

    optionGroups.forEach((group) => {
      const i = Number(group.dataset.option)
      $$('[data-value]', group).forEach((btn) => btn.addEventListener('click', () => choose(i, btn.dataset.value)))
    })
    stickySelects.forEach((sel) => sel.addEventListener('change', () => choose(Number(sel.dataset.stickyOption), sel.value)))

    $$('[data-qty-step]', root).forEach((btn) => btn.addEventListener('click', () => {
      qty = Math.min(99, Math.max(1, qty + Number(btn.dataset.qtyStep)))
      $('[data-qty-value]', root).textContent = qty
      $('[data-qty-input]', root).value = qty
      const stickyPrice = $('[data-sticky-price]', root)
      if (stickyPrice) stickyPrice.textContent = formatMoney(current().price * qty)
    }))

    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)))

    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        // Only once the button has scrolled up past the top, not while it is still below the fold.
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0
        sticky.classList.toggle('is-visible', show)
        sticky.setAttribute('aria-hidden', String(!show))
      })
      io.observe(mainAdd)
    }
  })

  /* ---------- Collection: filters, sort, sheets ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-sheet-open]')
    if (opener) {
      open($(`[data-sheet="${opener.dataset.sheetOpen}"]`))
      return
    }
    const closer = e.target.closest('[data-sheet-close]')
    if (closer) {
      close(closer.closest('[data-sheet]'))
      return
    }
    const sortItem = e.target.closest('[data-sort-value]')
    if (sortItem) goSort(sortItem.dataset.sortValue)
    const tab = e.target.closest('[data-filter-tab]')
    if (tab) {
      const root = tab.closest('[data-filter-tabs]')
      $$('[data-filter-tab]', root).forEach((t) => {
        const on = t === tab
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-selected', String(on))
      })
      $$('[data-filter-panel]', root).forEach((p) => { p.hidden = p.dataset.filterPanel !== tab.dataset.filterTab })
    }
  })

  function goSort(value) {
    const url = new URL(window.location.href)
    url.searchParams.set('sort_by', value)
    url.searchParams.delete('page')
    window.location.href = url.toString()
  }
  const sortSelect = $('[data-sort-select]')
  if (sortSelect) sortSelect.addEventListener('change', () => goSort(sortSelect.value))

  // Empty price boxes are left out so the URL only carries filters that are set.
  function submitFilters(form) {
    const params = new URLSearchParams()
    new FormData(form).forEach((value, key) => { if (value !== '') params.append(key, value) })
    const query = params.toString()
    window.location.href = form.action + (query ? `?${query}` : '')
  }
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(form) })
    if (form.hasAttribute('data-auto-submit')) {
      let timer
      form.addEventListener('change', (e) => {
        clearTimeout(timer)
        timer = setTimeout(() => submitFilters(form), e.target.type === 'checkbox' ? 0 : 600)
      })
    }
  })

  // Dual price slider kept in step with the number boxes.
  $$('[data-price-range]').forEach((range) => {
    const max = Number(range.dataset.max) || 0
    const sliders = { min: $('[data-price-slider="min"]', range), max: $('[data-price-slider="max"]', range) }
    const inputs = { min: $('[data-price-input="min"]', range), max: $('[data-price-input="max"]', range) }
    const fill = $('[data-price-fill]', range)
    const paint = () => {
      if (!max) return
      fill.style.left = `${(Number(sliders.min.value) / max) * 100}%`
      fill.style.right = `${100 - (Number(sliders.max.value) / max) * 100}%`
    }
    const fromSlider = (which) => {
      let lo = Number(sliders.min.value)
      let hi = Number(sliders.max.value)
      if (lo > hi) { if (which === 'min') lo = hi; else hi = lo }
      sliders.min.value = lo
      sliders.max.value = hi
      inputs.min.value = lo > 0 ? lo : ''
      inputs.max.value = hi < max ? hi : ''
      paint()
    }
    sliders.min.addEventListener('input', () => fromSlider('min'))
    sliders.max.addEventListener('input', () => fromSlider('max'))
    // Sliders have no name, so tell the form a price changed once the thumb is let go.
    ;['min', 'max'].forEach((k) => sliders[k].addEventListener('change', () => inputs[k].dispatchEvent(new Event('change', { bubbles: true }))))
    ;['min', 'max'].forEach((k) => inputs[k].addEventListener('input', () => {
      sliders[k].value = inputs[k].value === '' ? (k === 'min' ? 0 : max) : inputs[k].value
      paint()
    }))
    paint()
  })
})()
